import script from "./repair-order-detection.vue?vue&type=script&lang=ts&setup=true"
export * from "./repair-order-detection.vue?vue&type=script&lang=ts&setup=true"

import "./repair-order-detection.vue?vue&type=style&index=0&id=479b6ef0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-479b6ef0"]])

export default __exports__